module.exports = __webpack_public_path__ + "static/media/solar_21_logo_black.41e7f6e4.svg";